import './src/styles/global.css'
import './src/styles/splide.css'
import './src/styles/wysiwyg.css'
import '@splidejs/react-splide/css/core'
import { Amplify } from 'aws-amplify'
import outputs from './amplify_outputs.json'

// Amplify Gen 2 writes amplify_outputs.json at build time. The REST APIs are
// custom CDK resources, published under custom.API (see amplify/backend.ts).
Amplify.configure(outputs)
Amplify.configure({
  ...Amplify.getConfig(),
  API: { REST: outputs.custom?.API ?? {} },
})

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location && location.state)
    location.state.referrer = prevLocation ? prevLocation.pathname : null
}
